import React from 'react';
import './index.css';

const Loader = () => (
  <div className='wrap'>
    <div className='loadingDot'>.</div>
  </div>
);
export default Loader;
